<div class="v4-layout-field" [class.focus]="active">
  <div
    class="v4-layout-field-label first flex flex-row items-center justify-between flex-1 cursor-pointer"
    nz-popover
    nzPopoverTrigger="hover"
    [nzPopoverContent]="houseOverview"
    nzPopoverPlacement="left">
    <div class="flex flex-row items-center">
      <span
        class="pay-type"
        [class.cash]="entity.thirdparty_type === Platform.Ctrip && data.payment_type === 1"
        [class.advance]="entity.thirdparty_type === Platform.Ctrip && data.payment_type === 0"></span>
      <img
        class="channel-wrap mr-1"
        [src]="(data.thirdparty_type | thirdparty)?.icon_color"
        style="width: 20px; height: 20px" />
      <div class="leading-tight">
        <p
          class="break-all"
          nz-paragraph
          [nzEllipsis]="true"
          [nzEllipsisRows]="entity.thirdparty_type === Platform.Ctrip ? 1 : 2">
          {{ entity?.thirdparty_house_title }}
        </p>
        <!-- {{ (data.thirdparty_type | thirdparty)?.name }} -->
        <ng-container *ngIf="entity.thirdparty_type === Platform.Ctrip">
          <div class="extra whitespace-nowrap" (click)="data.displayCtripPriceForm = !data.displayCtripPriceForm">
            {{ "price.batch.form_item.ctrip_price" | translate }} {{ ctripReservePriceText(data) }}
            {{ "price.batch.form_item.commission" | translate }} {{ data.commission_rate * 100 }}
            %
            <img src="/assets/icon/play.svg" alt="" class="w-2 h-2" />
          </div>
        </ng-container>
      </div>

      <ng-template #houseOverview>
        <div class="house-overview-content">
          <div class="flex flex-row items-center">
            <img
              src="/assets/status/placeholder.png"
              hostPlaceholder
              [delaySrc]="entity?.c_cover_url"
              alt=""
              class="w-[60px] h-[40px] mr-[12px] rounded" />
            <div class="max-w-[250px]">
              <div class="flex flex-row items-center">
                <a [href]="entity?.housing_link" target="_blank" class="text-m ellipsis-line-2">{{
                  entity?.thirdparty_house_title
                }}</a>
              </div>

              <div class="flex flex-row items-center">
                <img
                  class="w-[16px] h-[16px] rounded-full"
                  [attr.src]="(entity.thirdparty_type | thirdparty)?.icon_color" />
                <span class="text-s ml-1">{{ entity?.account_username }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <span class="ml-[20px]">{{ data.currency_type }}</span>
  </div>
  <!-- <span class="label second">{{ data.currency_type }}</span> -->
  <div class="v4-layout-field-control !flex-none w-[120px]">
    <div class="v4-layout-field-row w-full relative" hostThousandsSeparator>
      <input
        #input
        nz-input
        nzSize="large"
        min="0"
        type="number"
        class="peer transition-none w-full"
        [disabled]="disabled"
        [(ngModel)]="data.price"
        (ngModelChange)="recalculateCtripPrice(data)"
        (wheel)="$event.preventDefault()"
        nz-popover
        [nzPopoverTrigger]="disabled ? 'hover' : null"
        [nzPopoverTitle]="null"
        [nzPopoverContent]="ratePlanWarnTpl"
        [placeholder]="formattedPlaceholder" />
      <div class="sep-tpl hidden absolute top-1/2 left-[12px] -translate-y-1/2 pointer-events-none" #sepTpl>
        {{ formattedPrice }}
      </div>

      <ng-template #ratePlanWarnTpl>
        <span class="text-m">{{ "price-calendar_html_rate_plan_click_disabeld_tip" | translate }}</span>
      </ng-template>
    </div>
  </div>
</div>
<ng-container *ngIf="data.thirdparty_type === Platform.Ctrip">
  <!--  <div-->
  <!--    class="ctrip-price-tip"-->
  <!--    *ngIf="true || !data.displayCtripPriceForm">-->
  <!--    {{ "ctrip.reserve_price" | translate }}-->
  <!--    {{ ctripReservePriceText(data) }}-->
  <!--    {{ "ctrip.commission" | translate }}-->
  <!--    {{ data.commission_rate * 100 | number:'1.0-0'  }}%-->
  <!--  </div>-->
  <div class="ctrip-commission">
    <host-ctrip-price-form
      *ngIf="data.displayCtripPriceForm"
      [paymentType]="data.payment_type"
      [commission]="data.commission_rate * 100"
      [reservePrice]="data.reserve_price"
      [salePrice]="data.price"
      (onClear)="onClearCtripPriceForm(data)"
      (onConfirm)="onConfirmCtripPriceForm(data, $event)"></host-ctrip-price-form>
  </div>
</ng-container>
